<script lang="ts">
    import src from './svg/toll_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    scale = scale * 0.9;
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />